import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'position_title', label: 'Position' },
  { key: 'type', label: 'Type' },
  { key: 'entitled_days', label: 'Entitled', align: 'right' },
  { key: 'used_days', label: 'Used', align: 'right' },
  { key: 'remaining_days', label: 'Remaining', align: 'right' },
];

export function LeaveBalancesReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Leave Balances"
      description="Entitled, used and remaining leave days per employee and type for the current year."
      endpoint="/reports/hr/leave-balances"
      columns={COLUMNS}
      filters={['category']}
      categoryOptions={listOptions(lists, 'leave_type')}
      listColumns={{ type: 'leave_type' }}
    />
  );
}
